import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      class: "fill",
      d: "M10.8592 3.51249C11.2192 2.40729 12.7828 2.40729 13.1416 3.51249L14.4256 7.46289C14.504 7.70348 14.6565 7.91311 14.8612 8.06182C15.066 8.21053 15.3125 8.29071 15.5656 8.29089H19.72C20.8828 8.29089 21.3652 9.77889 20.4256 10.4629L17.0656 12.9037C16.8604 13.0525 16.7076 13.2625 16.6292 13.5035C16.5507 13.7445 16.5506 14.0042 16.6288 14.2453L17.9128 18.1957C18.2728 19.3009 17.0068 20.2213 16.0648 19.5373L12.7048 17.0965C12.4998 16.9477 12.253 16.8676 11.9998 16.8676C11.7465 16.8676 11.4997 16.9477 11.2948 17.0965L7.93476 19.5373C6.99396 20.2213 5.72916 19.3009 6.08796 18.1957L7.37196 14.2453C7.45017 14.0042 7.45003 13.7445 7.37156 13.5035C7.29309 13.2625 7.14032 13.0525 6.93516 12.9037L3.57636 10.4641C2.63676 9.78009 3.12036 8.29209 4.28196 8.29209H8.43516C8.68842 8.29216 8.9352 8.2121 9.14019 8.06337C9.34517 7.91464 9.49785 7.70487 9.57636 7.46409L10.8604 3.51369L10.8592 3.51249Z",
      fill: "#212225"
    }, null, -1)
  ])))
}
export default { render: render }